<template>
  <div
    class="animate__bounceIn animate__animated voice-call horizontal layout center center-justified"
  >
    <div class="text-center" style="width: 100%">
      <div class="title">
        🌟 {{ $t('Presenter is calling…') }}
      </div>
      <div class="horizontal layout center center-justified setting-call">
        <!-- <div
          class="setting-call-item"
          :class="{'disabled': !optionCall.audio}"
          @click="optionCall.audio = !optionCall.audio"
        >
          <i class="fas fa-microphone" />
        </div> -->
        <div
          class="setting-call-item horizontal layout center center-justified"
          :class="{'disabled': !optionCall.video}"
          @click="optionCall.video = !optionCall.video"
        >
          <i class="fas fa-video fa-fw" />
        </div>
      </div>
      <button class="button button-accept" @click="accept()">
        {{ $t('Accept') }}
      </button>
      <div class="decline" @click="decline()">
        <i class="fas fa-phone" />
        {{ $t('Decline') }}
      </div>
    </div>
    <audio src="https://s3.amazonaws.com/public.ahaslide.com/static/ring-call/ring-call.mp3" id="play-call" loop />
  </div>
</template>

<script>
import config from '@/config'
import utils from '@/util'

export default {
  data() {
    return {
      optionCall: {
        video: true,
        audio: true,
      },
    }
  },
  mounted() {
    document.getElementById('play-call').play()
  },
  methods: {
    async accept() {
      document.getElementById('play-call').pause()
      this.$store.state.voiceCall = {
        isOpen: true,
        status: 'during-call',
        video: this.optionCall.video,
        audio: this.optionCall.audio,
      }
      const slideName = utils.getCorrectSlideTypeName(this.$store.state.slide)
      utils.mixpanelTrack('Video Call', 'Audience Accept Call', slideName)
    },
    decline() {
      this.$store.state.voiceCall.isOpen = false
      this.$http.post(config.api.stopVideoCall, {
        audienceUnique: this.$store.state.audienceId,
        uniqueAccessCode: this.$store.state.presentation.uniqueAccessCode,
      })
      const slideName = utils.getCorrectSlideTypeName(this.$store.state.slide)
      utils.mixpanelTrack('Video Call', 'Audience Declines Call', slideName)
    },
  },
}
</script>

<style lang="scss" scoped>
.voice-call {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000bf;
  z-index: 1000;
  color: #fff;
  padding: 16px;
}
.title {
  font-size: 28px;
  margin-bottom: 32px;
  font-weight: bold;
}
.setting-call-item {
  background-color: #cdffcd;
  color: #2d9c2d;
  width: 60px;
  height: 40px;
  border-radius: 30px;
  font-size: 20px;
  margin: 0 8px;
  cursor: pointer;
  position: relative;
  margin-bottom: 16px;

  &.disabled {
    background-color: #ffd2d2;
    color: red;
    &::before {
      content: "";
      display: block;
      width: 2px;
      height: 30px;
      position: absolute;
      top: 3px;
      background-color: red;
      left: 50%;
      transform: rotate(-45deg);
      border-radius: 2px;
    }
  }
}

button.button-accept {
  background: #15A962;
  border: 1px solid #F4F4F4;
  border-radius: 26px;
  max-width: 400px;
  width: 100%;
  font-size: 20px;
  height: 48px;
  display: block;
  margin: 16px auto;
}
.decline {
  font-size: 20px;
  margin: 16px 0;
  display: inline-block;
  cursor: pointer;

  i {
    transform: rotate(-135deg);
    margin-right: 8px;
  }
}
</style>
